import {
  WT_SURVEY_EVENT_CLICKED,
  WT_SURVEY_EVENT_DISMISSED,
  WT_SURVEY_EVENT_SHOWN,
  WT_SURVEY_VERSION,
  type WtSurveyDismissAction,
} from './constants';

type Payload = Record<string, string | number | boolean>;
export type WtSurveyTrackFn = (eventName: string, payload?: Payload) => void;

const buildPayload = (extra: Payload = {}): Payload => ({
  surveyVersion: WT_SURVEY_VERSION,
  surveyShownPathname: typeof window !== 'undefined' ? window.location.pathname : '',
  ...extra,
});

export const trackWtSurveyShown = (track: WtSurveyTrackFn): void => {
  track(WT_SURVEY_EVENT_SHOWN, buildPayload());
};

export const trackWtSurveyClicked = (track: WtSurveyTrackFn): void => {
  track(WT_SURVEY_EVENT_CLICKED, buildPayload());
};

export const trackWtSurveyDismissed = (track: WtSurveyTrackFn, dismissAction: WtSurveyDismissAction): void => {
  track(WT_SURVEY_EVENT_DISMISSED, buildPayload({ dismissAction }));
};
